import React, {useState, useEffect, useCallback} from "react"
import ComponentWrapper from "components/HOC/ComponentWrapper"
import {get, post} from "helpers/api"
import styled from "styled-components"
import {Button} from "@uprise/button"
import {text} from "@uprise/typography"
import {Card} from "@uprise/card"
import {spacing} from "@uprise/spacing"
import {Modal} from "@uprise/modal"
import {H4, H5, H6} from "@uprise/headings"
import toast, { Toaster } from 'react-hot-toast';
import DropDown from "components/shared/DropDown"

export const HeaderTableContent = styled.div`
	display: flex;
`

export const CustomButton = styled(Button)`
	margin-left: 50px;
	width: 100px;
	height: 43px;
`
const FormInputContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`
const TextInput = styled.input`
	margin-left: 10px;
	margin-bottom: 0px;
	width: 60%;
	font-size: 14px;
	height: 40px;
	border-radius: 5px;
	border-width: 0.7px;
	padding-left: 10px;
	padding-right: 10px;
`
const FormLabel = styled.label``
const Checkbox = styled.input`
	margin: 0;
	padding: 0;
`
const FunctionContainer = styled.div`
	display: flex;
`
const FunctionTitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-itmes: center;
	width: 80%;
	margin-top: 50px;
`
const AllFunctionContainer = styled.div`
	display: flex;
	flex-direction: column;
`
const FunctionName = styled.h5`
	margin-top: 10px;
	margin-bottom: 5px;
	font-size: 16px;
`
const FunctionSubName = styled.h6`
	margin-top: 10px;
	margin-bottom: 5px;
	margin-left: 10px;
	font-weight: normal;
	font-size: 14px;
`
const CheckboxContainer = styled.div`
	margin-top: 10px;
	// margin-bottom: 5px;
`

const EditRole = props => {
	const {
		location: {
			state: {roleId}
		},
		history
	} = props
	const [allModules, setAllModules] = useState([])
	const [allRoles, setAllRoles] = useState([])
	const [selectedRoleId, setSelectedRoleId] = useState(roleId)

	const clearAllCheckboxes = data => {
		data.forEach(item => {
			item["view_checked"] = false
			item["all_checked"] = false
			item?.children?.length > 0 &&
				item.children.forEach(child => {
					child["view_checked"] = false
					child["all_checked"] = false
				})
		})
		setAllModules(data)
	}

	const getAllModules = async () => {
		const modules = await get("crmModules")
		if (modules?.message?.length > 0) {
			const data = modules.message
			clearAllCheckboxes(data)
		}
	}

	const getAllRoles = async () => {
		const modules = await get("roles")

		if (modules?.message?.length > 0) {
			const data = modules.message
			data.forEach(item => {
				item["label"] = item.roleName
				item["value"] = item.id
			})
			setAllRoles(data)
		}
	}

	const toggleModulesInitialCheck = () => {
        clearAllCheckboxes(allModules)
		const initialRole = allRoles.filter(item => parseInt(item.id) === parseInt(selectedRoleId))
		if (initialRole?.length > 0) {
			const data = allModules
			initialRole[0]?.modules.forEach(module => {
				const {moduleId, accessType} = module
				data.forEach(item => {
					if (parseInt(item.id) === parseInt(moduleId)) {
						if (accessType === "VIEW") {
							item["view_checked"] = true
						} else if (accessType === "ALL") {
							item["all_checked"] = true
							item["view_checked"] = true
						}
					}
					item?.children?.length > 0 &&
						item?.children?.forEach(child => {
							if (parseInt(child.id) === parseInt(moduleId)) {
								if (accessType === "VIEW") {
									child["view_checked"] = true
								} else if (accessType === "ALL") {
									child["all_checked"] = true
									child["view_checked"] = true
								}
							}
						})
				})
			})

			setAllModules([...data])
		}
	}

	const onLoad = async () => {
		await getAllModules()
		await getAllRoles()
	}

	useEffect(() => {
		onLoad()
	}, [])

	useEffect(() => {
		if (selectedRoleId && allRoles?.length > 0) {
			toggleModulesInitialCheck()
		}
	}, [selectedRoleId, allRoles])

	const getInitialRole = () => {
		const initialRole = allRoles.filter(item => item.id === selectedRoleId)
		return {label: initialRole?.[0]?.label, value: initialRole?.[0]?.value}
	}

	const onDropdownChange = e => {
		setSelectedRoleId(e.id)
	}
	const renderRoleDropdown = () => {
		return (
			<DropDown
				variant='primary'
				items={allRoles}
				label='Select Role'
				disabled={false}
				menuStyle={{
					width: "300px",
                    // wordBreak:'break-all'
                    position: "absolute", zIndex: 2
				}}
				containerStyle={{
					width: "300px",
					marginLeft: "20px",
                    wordBreak:'break-all'
				}}
				buttonStyles={{
					padding: 10,
                    wordBreak:'break-all'
				}}
				isLast
				onChange={onDropdownChange}
				initialSelectedItem={allRoles?.length > 0 ? getInitialRole() : ""}
			/>
		)
	}

	const onViewOnlyCheckChange = (parentId, childId) => {
		const data = allModules
		data.forEach(item => {
			if (parseInt(item.id) === parseInt(parentId)) {
				if (!childId) {
					item["view_checked"] = !item["view_checked"]
				}

				item?.children?.length > 0 &&
					item.children.forEach(child => {
						if (childId && parseInt(child.id) === parseInt(childId)) {
							child["view_checked"] = !child["view_checked"]
						} else if (!childId) {
							child["view_checked"] = item["view_checked"]
						}
					})
			}
		})
		setAllModules([...data])
	}

	const onAllCheckChange = (parentId, childId) => {
		const data = allModules
		data.forEach(item => {
			if (parseInt(item.id) === parseInt(parentId)) {
				if (!childId) {
					item["all_checked"] = !item["all_checked"]
					item["view_checked"] = item["all_checked"]
				}

				item?.children?.length > 0 &&
					item.children.forEach(child => {
						if (childId && parseInt(child.id) === parseInt(childId)) {
							child["all_checked"] = !child["all_checked"]
							child["view_checked"] = child["all_checked"]
						} else if (!childId) {
							child["all_checked"] = item["all_checked"]
							child["view_checked"] = item["view_checked"]
						}
					})
			}
		})
		setAllModules([...data])
	}

	const renderFunctions = () => {
		return (
			<FunctionContainer>
				<FunctionTitleContainer>
					<AllFunctionContainer>
						<H4>Functions</H4>
						{allModules?.map((item, pIndex) => {
							return (
								<div key={pIndex}>
									<FunctionName>{item?.name}</FunctionName>
									{item?.children?.length > 0 &&
										item.children.map((child, childIndex) => {
											return <FunctionSubName key={childIndex}>{child?.name}</FunctionSubName>
										})}
								</div>
							)
						})}
					</AllFunctionContainer>
					<AllFunctionContainer
						style={{
							justifyContent: "center",
							alignItems: "center"
						}}>
						<H4>View Only</H4>
						{allModules?.map((item, pIndex) => {
							return (
								<div key={pIndex}>
									<CheckboxContainer>
										<Checkbox
											type='checkbox'
											value={item.id}
											onClick={() => onViewOnlyCheckChange(item.id, null)}
											checked={item.view_checked}
											disabled={item.all_checked}
										/>
									</CheckboxContainer>
									{item?.children?.length > 0 &&
										item.children.map((child, childIndex) => {
											return (
												<CheckboxContainer key={childIndex}>
													<Checkbox
														type='checkbox'
														value={child.id}
														onClick={() => onViewOnlyCheckChange(item.id, child.id)}
														checked={child.view_checked}
														disabled={child.all_checked}
													/>
												</CheckboxContainer>
											)
										})}
								</div>
							)
						})}
					</AllFunctionContainer>
					<AllFunctionContainer
						style={{
							justifyContent: "center",
							alignItems: "center"
						}}>
						<H4>All access</H4>
						{allModules?.map((item, pIndex) => {
							return (
								<div key={pIndex}>
									<CheckboxContainer>
										<Checkbox
											type='checkbox'
											value={item.id}
											onClick={() => onAllCheckChange(item.id, null)}
											checked={item.all_checked}
										/>
									</CheckboxContainer>
									{item?.children?.length > 0 &&
										item.children.map((child, childIndex) => {
											return (
												<CheckboxContainer key={childIndex}>
													<Checkbox
														type='checkbox'
														value={child.id}
														onClick={() => onAllCheckChange(item.id, child.id)}
														checked={child.all_checked}
													/>
												</CheckboxContainer>
											)
										})}
								</div>
							)
						})}
					</AllFunctionContainer>
				</FunctionTitleContainer>
			</FunctionContainer>
		)
	}

	const onSubmit = () => {
		if (!roleId) {
			toast.error("Please select valid role")
			return
		}
		let isFunctionSelected = false
		allModules.forEach(item => {
			if (item.view_checked || item.all_checked) {
				isFunctionSelected = true
			}
			item?.children?.length > 0 &&
				item?.children?.forEach(subItem => {
					if (subItem.view_checked || subItem.all_checked) {
						isFunctionSelected = true
					}
				})
		})
		if (!isFunctionSelected) {
			toast.error("Please add valid role functions")
			return
		}
		let data = []
		allModules.forEach(item => {
			if (item["view_checked"] || item["all_checked"]) {
				data.push({moduleId: item.id, accessType: item["all_checked"] ? "ALL" : "VIEW"})
				item?.children?.length > 0 &&
					item.children.forEach(child => {
						if (child["view_checked"] || child["all_checked"]) {
							data.push({moduleId: child.id, accessType: item["all_checked"] ? "ALL" : "VIEW"})
						}
					})
			}
		})
		post("role/editRole", {
			modules: data,
			roleId: selectedRoleId
		})
			.then(result => {
				console.log('result',result)
				if (result.code === "success") {
					toast(result.message)
                    setSelectedRoleId('')
                    onLoad()
					history.push("/roles")
				} else {
					toast.error("Error while adding role")
				}
			})
			.catch(error => {
				console.log(error)
				toast.error("Error while adding role")
			})
	}

	return (
		<ComponentWrapper menuActiveIndex={17} subMenuActiveIndex={17} headerTitle='Edit Role'>
			<Card padding={spacing.s10} backgroundColor='white'>
				{(allRoles?.length > 0 && allModules?.length) > 0 ? (
					<>
						<FormInputContainer>
							<FormLabel>Role Name</FormLabel>
							{renderRoleDropdown()}
							<CustomButton title={"Save"} variant={"primary"} onClick={onSubmit} />
						</FormInputContainer>

						{renderFunctions()}
					</>
				) : (
					<></>
				)}
			</Card>
			<Toaster />
		</ComponentWrapper>
	)
}

export default EditRole
